import { Edge, Node } from 'reactflow';
import { LayoutAlgorithm } from './utils/types';
import { hierarchy } from './utils/hierarchy';
import { layout } from './utils/layout';

export const layoutAlgorithm: LayoutAlgorithm = async (nodes: Node[], edges: Edge[]) => {
  const tree = hierarchy(nodes, edges);
  const layoutNodes = layout(tree);

  return { nodes: layoutNodes, edges };
};
